import React from "react";

import Trade from "./Trade";
import { getLocalUserInfoLocalStorage, statuses } from "../utils/utils";

function Column(props) {
    const { trades, customerDetailsTradeInfo, status, columnIndex, landScape } = props;
    const {
        showStoreName,
        showCustomerId, showCustomerFirstName, showCustomerLastName,
        showWaitTime
    } = getLocalUserInfoLocalStorage();
    const onlyOrderNumber = !(showStoreName || showCustomerId || showWaitTime || showCustomerFirstName || showCustomerLastName);

    if (trades.length !== 0) {
        trades.sort((t1, t2) => {
            const id1 = t1.orderCallNumber || t1.pagerIdentifier || t1.id;
            const id2 = t2.orderCallNumber || t2.pagerIdentifier || t2.id;
            return `${id1}`.localeCompare(`${id2}`, undefined, { numeric: true });
        });
        return (
            <div className={"trade-container" + (onlyOrderNumber ? " only-order-number" : "")}
                 style={{ gridTemplateColumns: landScape ? 'grid-template-columns: repeat(6, minmax(200px, max-content))' : 'grid-template-columns: repeat(auto-fit, minmax(200px, max-content))' }}>
                <Trade key={status}
                       trades={trades.filter(trade => {
                           return status === statuses[0] ?
                               trade.state in [1, 2, 3, 4] :
                               trade.state === 6;
                       })}
                       columnIndex={columnIndex}
                       customerDetailsTradeInfo={customerDetailsTradeInfo}
                       status={props.status} />
            </div>
        );
    } else {
        return (
            <div>

            </div>
        )
    }
}

export default (Column);
